/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `backend` - Backend
 * `frontend` - Frontend
 */
export type SourceCa3Enum = (typeof SourceCa3Enum)[keyof typeof SourceCa3Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceCa3Enum = {
  backend: "backend",
  frontend: "frontend",
} as const;
